import { useContext } from 'react';
import { WorkflowModes, WorkflowModesID } from '../../__generated__/constants';
import { DSPModeContext } from './DspDevModeProvider';
import { useLocation } from 'react-router';

export const castDSPDevMode = (
  value: string | WorkflowModesID
): WorkflowModesID => {
  switch (Number(value)) {
    case WorkflowModes.PRODUCTION.id:
      return WorkflowModes.PRODUCTION.id;
    case WorkflowModes.TEST.id:
      return WorkflowModes.TEST.id;
    default:
      throw new Error(`Invalid DSPDevMode value: ${value}`);
  }
};

export const useDspWorkflowMode = (ignorePath = false) => {
  const ctx = useContext(DSPModeContext);
  if (!ctx) {
    throw new Error(
      'useDspWorkflowMode must be used within a DspDevModeProvider'
    );
  }

  const location = useLocation();
  const [devMode, setDevMode] = ctx;

  return [
    ignorePath || location.pathname.startsWith('/dsp/')
      ? devMode
      : WorkflowModes.PRODUCTION.id,
    setDevMode,
  ] as const;
};

export const useDspWorkflowModeCheck = (
  mode: WorkflowModesID = WorkflowModes.PRODUCTION.id
) => {
  const [currentMode] = useDspWorkflowMode(true);
  return currentMode === mode;
};
